import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { createNotification } from "../components/Popup";
import { protectedApi } from "../services/apiService";

/**
 * Shared hook for executing application management API calls.
 * Handles loading state, unauthorized redirects, and error dispatch.
 */
const useApplicationManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleApplicationManagement = async (payload, apiUrl) => {
    setIsLoading(true);
    try {
      const result = await protectedApi(payload, apiUrl);
      if (result?.code === 1) {
        if (result?.data) {
          return result;
        }
      } else if (result?.code === 3) {
        setIsLoading(false);
        navigate("/");
        sessionStorage.clear();
        localStorage.clear();
        const info = { type: "error", message: result?.message };
        return createNotification(info)();
      } else {
        setIsLoading(false);
        return result;
      }
    } catch (error) {
      // Error notification is already dispatched by protectedApi
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, handleApplicationManagement };
};

export default useApplicationManagement;
